import { Page } from '@/core/architecture'

import { BankCreateTemplate } from './template'
import { useViewModel } from './viewModel'

/**
 * BankCreate Page
 * Implemented as a practical sample.
 */
export const BankCreate: Page = () => {
  const { state, actions } = useViewModel()

  return <BankCreateTemplate state={state} {...actions} />
}
